import PixelCreatePage from "../components/pixel/create";
import PixelRoiCreatePage from "../components/pixel/create/roi";
import PixelEditPage from "../components/pixel/edit";
import PixelRoiEditPage from "../components/pixel/edit/roi";
import { PixelsPage } from "../components/pixel/index";
import RetargetingSegmentCreatePage from "../components/retargeting-segments/create";
import RetargetingSegmentEditPage from "../components/retargeting-segments/edit";
import RetargetingSegmentsPage from "../components/retargeting-segments/index";

export const Routes = (flags = {}) => {
  const { whitelabelEventPixelCreateButton, whitelabelRoiPixelEnabled, whitelabelRetargetingSegments } = flags;

  const routes = [
    {
      component: PixelsPage,
      path: "/pixels",
      title: ["Pixels"],
    },
    {
      component: PixelEditPage,
      path: "/pixel/edit/:pixel_id",
      title: ["Pixels", "Edit"],
    },
  ];

  if (whitelabelEventPixelCreateButton) {
    routes.push({
      component: PixelCreatePage,
      path: "/pixel/create",
      title: ["Pixels", "Create"],
    });
  }

  if (whitelabelRoiPixelEnabled) {
    routes.push(
      {
        component: PixelRoiCreatePage,
        path: "/pixel-roi/create",
        title: ["Pixels", "ROI", "Create"],
      },
      {
        component: PixelRoiEditPage,
        path: "/pixel-roi/edit/:pixel_id",
        title: ["Pixels", "ROI", "Edit"],
      },
    );
  }

  if (whitelabelRetargetingSegments) {
    routes.push(
      {
        component: RetargetingSegmentsPage,
        path: "/retargeting-segments",
        title: ["Brand and SKU Segments"],
      },
      {
        component: RetargetingSegmentCreatePage,
        path: "/retargeting-segments/create",
        title: ["Brand and SKU Segments", "Create"],
      },
      {
        component: RetargetingSegmentEditPage,
        path: "/retargeting-segments/:segmentId/edit",
        title: ["Brand and SKU Segments", "Edit"],
      },
    );
  }

  return routes;
};
